import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library';

export const StyledStaticWrapper = styled.div`
  .language-modal .language-modal__container .language-modal-close-btn {
    [dir='rtl'] & {
      left: 0 !important;
      width: unset !important;
    }
  }
`;
